import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Typography from "@mui/material/Typography";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";
import FormProvider from "./FormProvider";
import DirectionSnackbar from "../Alert/Alert";
import TextFieldicon from "./TextField_icon";
import LoadingButton from "@mui/lab/LoadingButton";
import Loading from "../Loading/CircularDeterminate";
import { useAuth } from "../Auth/AuthProtecter";

export default function FormEditUser({ name, ...pros }) {
  const auth = useAuth();
  const { person, email } = auth.infoUserDasboard;

  const [datai, setArrayUseri] = React.useState(false);

  useEffect(() => {
    //
    setArrayUseri(person);
    //
  });

  const url = process.env.REACT_APP_API_UPDATE_DATAUSER; // Conection Api

  const [status, setStatus] = useState(false);
  const [messenger, setMessenger] = useState("");
  const [severity, setSeverity] = useState("");
  const idusder = pros.id;

  const RegisterSchema = Yup.object().shape({
    firstname: Yup.string()
      .required("Nombre de su empresa no puede ir vacio")
      .min(4, "lo minimo son 4 caracteres"),
    lastname: Yup.string()
      .required("Nombre de usuario no puede estar vacio")
      .min(4, "lo minimo son 4 caracteres"),
  });

  const defaultValues = {
    firstname: 0,
  };
  // const defaultValues = {
  //   firstname: data["firstname"],
  //   lastname: data["lastname"],
  //   birthdate: data["birthdate"],
  // };

  const methods = useForm({
    resolver: yupResolver(RegisterSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (e) => {
    const birthdate = new Date(e.birthdate).toLocaleDateString("en-US");

    const values = {
      firstname: e.firstname,
      lastname: e.lastname,
      birthdate: birthdate,
    };

    try {
      const CONFIG_JSON = {
        method: "POST",
        headers: {
          referrerPolicy: "unsafe_url",
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          mode: "same-origin",
        },
        body: JSON.stringify(values),
      };

      const res = await fetch(`${url}${idusder}`, CONFIG_JSON);
      // const res_api = await res.json();

      if (res.status === 200) {
        setStatus(true);
        setMessenger("Datos actualizados");
        setSeverity("success");
      }
      if (res.status !== 200) {
        setStatus(true);
        setMessenger("Ocurrio un error...");
        setSeverity("error");
      }

      window.setTimeout(() => {
        setStatus(false);
      }, 4000);
    } catch (error) {
      if (error) {
        setStatus(true);
        setMessenger("Ups, error de conexión...");
        setSeverity("error");
      }

      window.setTimeout(() => {
        setStatus(false);
      }, 4000);
    }
  };
  console.log(person);

  return datai ? (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Datos de usuario
      </Typography>
      <DirectionSnackbar
        open={status}
        severity={severity}
        messenger={messenger}
      />

      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextFieldicon
              value={person.firstname}
              id="firstname"
              name="firstname"
              label="Nombre"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextFieldicon
              value={person.middlename}
              id="lastname"
              name="lastname"
              label="Nombre 2"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextFieldicon
              id="lastname"
              name="lastname"
              label="Apellido"
              value={person.lastname}
              //              type="date"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextFieldicon
              id="secondlastname"
              name="secondlastname"
              value={person.secondlastname}
              label="Apellido 2"
            />
          </Grid>
          {/* <Grid item xs={12} sm={6}>
            <LoadingButton
              sx={{ mt: 2, mb: 2 }}
              fullWidth
              type="submit"
              variant="contained"
              loading={isSubmitting}
            >
              Guardar cambios
            </LoadingButton>
          </Grid> */}
        </Grid>
      </FormProvider>
    </React.Fragment>
  ) : (
    <>
      <Loading />
    </>
  );
}
